import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchWebsiteQueryQueuesService,
  updateWebsiteQueryQueueService,
  AssignToWebsiteQueryService,
} from "../../services";
import { appendWebsiteQueryQueues, removeSingleWebsiteQueryQueue, setWebsiteQueryQueues } from "./slice";
import { setAlert } from "../basicSlices";
import { handleLoadQuery } from "../query";
import { store } from "..";
import {
  ASSIGN_TO_WEBSITE_QUERY_QUEUE,
  FETCH_WEBSITE_QUERY_QUEUE_LIST,
  UPDATE_WEBSITE_QUERY_QUEUE,
  FETCH_TERMS,
} from "./types";

// function* handleLoadWebsiteQueryQueues() {
//   try {
//     const responseData: any = yield call(fetchWebsiteQueryQueuesService);

//     yield put(setWebsiteQueryQueues(responseData?.result?.data));
//   } catch (error: any) {
//     yield put(
//       setAlert({
//         text: error?.message,
//         type: "danger",
//         title: "Failed to fetch Website Query Queues!",
//       })
//     );
//   }
// }

function* handleLoadWebsiteQueryQueues({
  payload,
}: {
  payload?: { page?: number };
}): Generator<any> {
  const page = payload?.page ?? 1;

  try {
    const responseData: any = yield call(
      fetchWebsiteQueryQueuesService,
      page
    );

    const result = responseData?.result;
    const meta = {
      data: result?.data ?? [],
      currentPage: result?.current_page ?? 1,
      lastPage: result?.last_page ?? 1,
      total: result?.total ?? 0,
    };

    if (page === 1) {
      yield put(setWebsiteQueryQueues(meta));
    } else {
      yield put(appendWebsiteQueryQueues(meta));
    }
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to fetch Website Query Queues!",
      })
    );
  }
}

function* handleUpdateWebsiteQueryQueues({
  payload,
}: {
  payload: any;
}): Generator<any> {
  try {
    const responseData: any = yield call(
      updateWebsiteQueryQueueService,
      payload
    );
    yield handleLoadWebsiteQueryQueues({});
    if (payload?.query_id) {
      yield handleLoadQuery({ payload: { id: payload?.query_id } });
    }
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to update the Query Queue!",
      })
    );
  } finally {
    payload?.callback && payload?.callback();
  }
}

function* handleAssignToWebsiteQueryQueue({
  payload,
}: {
  payload: any;
}): Generator<any> {
  try {
    yield put(removeSingleWebsiteQueryQueue(payload?.query_id));
    const responseData: any = yield call(AssignToWebsiteQueryService, payload);
    yield handleLoadQuery({
      payload: {
        id: payload?.query_id ? payload?.query_id : payload?.id,
        canView: payload?.for == 1,
      },
    });
    payload?.callback && payload?.callback(false, responseData?.id);
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to assign this Query!",
      })
    );
    payload?.callback && payload?.callback(true);
  }
}

function* fetchTerms() {
  try {
    const responseData: any = yield call(() =>
      fetch("/get-terms").then((res) => res.json())
    );
    return responseData?.result?.data || [];
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to fetch Terms!",
      })
    );
  }
}

export default function* websiteQueryQueueSaga() {
  yield takeLatest<any>(
    FETCH_WEBSITE_QUERY_QUEUE_LIST,
    handleLoadWebsiteQueryQueues
  );
  yield takeLatest<any>(
    UPDATE_WEBSITE_QUERY_QUEUE,
    handleUpdateWebsiteQueryQueues
  );
  yield takeLatest<any>(
    ASSIGN_TO_WEBSITE_QUERY_QUEUE,
    handleAssignToWebsiteQueryQueue
  );
  yield takeLatest<any>(FETCH_TERMS, fetchTerms);
}
